import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-client-financials',
  templateUrl: './client-financials.component.html',
  styleUrls: ['./client-financials.component.scss']
})
export class ClientFinancialsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
